
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"13","viewBox":"0 0 22 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.1002 11.9334C14.1002 12.3752 14.4585 12.7334 14.9002 12.7334H20.4672C20.909 12.7334 21.2672 12.3752 21.2672 11.9334V6.36646C21.2672 5.92464 20.909 5.56646 20.4672 5.56646C20.0254 5.56646 19.6672 5.92464 19.6672 6.36646V10.002L12.7438 3.07866C12.4314 2.76626 11.9249 2.76626 11.6125 3.07866L7.91143 6.77962L1.36568 0.233862C1.05327 -0.0785379 0.546738 -0.0785379 0.234314 0.233862C-0.0781046 0.546262 -0.0781046 1.05282 0.234314 1.36522L7.34578 8.47669C7.65823 8.7891 8.16472 8.7891 8.47712 8.47669L12.1782 4.77571L18.5358 11.1334H14.9002C14.4585 11.1334 14.1002 11.4916 14.1002 11.9334Z","fill":"#8338EC"}})])
          )
        }
      }
    